document.addEventListener('DOMContentLoaded', function () {
  const loader = document.getElementById('copper-john-loader');
  const content = document.getElementById('body-content-to-load');
  const hasVisitedBefore = sessionStorage.getItem('hasVisitedBefore');

  if (!hasVisitedBefore) {
    sessionStorage.setItem('hasVisitedBefore', 'true');
    setTimeout(function() {
      loader.style.transition = 'opacity 1s ease';
      loader.style.opacity = '0';

      setTimeout(function() {
        loader.style.display = 'none';
        content.classList.add('unhide-main-content');
      }, 1000);
    }, 1000);
  } else {
    loader.style.display = 'none';
    content.classList.add('unhide-main-content');
  }
});